import { render } from "./Ball.vue?vue&type=template&id=32fa8d30&scoped=true"
import script from "./Ball.vue?vue&type=script&lang=js"
export * from "./Ball.vue?vue&type=script&lang=js"

import "./Ball.vue?vue&type=style&index=0&id=32fa8d30&scoped=true&lang=css"

import exportComponent from "G:\\web\\webprog\\wk_hello_world\\wk_ball_01_10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fa8d30"]])

export default __exports__